export type AccessGateReason = "login-required" | "insufficient-role";

export type AccessGateDetail = {
    reason: AccessGateReason;
    returnUrl?: string;
};

export const openAccessGateModal = (detail: AccessGateDetail) => {
    if (typeof window === "undefined") return;
    try {
        window.dispatchEvent(
            new CustomEvent<AccessGateDetail>("pc-access-gate", {
                detail,
            })
        );
    } catch {
        /* no-op */
    }
};
